export default __webpack_public_path__ + "static/media/photo1-rMAX.33227cd3.jpg";